import React from "react";
import { Typography, Button } from "antd";
import { WhatsAppOutlined, HeartFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import partner from "../assets/home/partner.png";
import u1 from "../assets/home/u1.png";
import u2 from "../assets/home/u2.png";
import u3 from "../assets/home/u3.jpg";

const { Title, Paragraph } = Typography;

const upcomingEvents = [
  {
    img: u1,
    name: "Football",
    text: "We're conducting open tournaments in Football, Cricket and Jiu-Jitsu for all to join and compete.",
    path: "/heroes-day",
  },
  {
    img: u2,
    name: "Cricket",
    text: "We're conducting The Heroes Cup to honor the workforce through sport.",
    path: "/bloom-day",
  },
  {
    img: u3,
    name: "Jiu-Jitsu",
    text: "Bloom Day brings smiles: A day of outdoor fun for special children and their families.",
    path: "/open-events",
  },
];

const Volunteer = () => {
  const navigate = useNavigate();

  const handleEventClick = (path) => {
    navigate(path);
  };

  const handleJoinVolunteer = () => {
    navigate("/contact-form");
  };

  return (
    <div style={{ width: "100%", overflowX: "hidden", boxSizing: "border-box" }}>
      {/* Hero Section */}
      <div style={{ width: "100%", height: "100vh", position: "relative", overflow: "hidden" }}>
        <img
          src={partner}
          alt="Partner"
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        {/* Overlay Content */}
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            color: "#fff",
            padding: "0 5%",
            maxWidth: "90%",
          }}
        >
          {/* Title */}
          <Title
            level={1}
            style={{
              color: "#fff",
              fontWeight: 900,
              fontSize: "clamp(28px, 5vw, 50px)",
              marginBottom: 10,
              textShadow: "2px 2px 10px rgba(0,0,0,0.7)",
              lineHeight: 1.2,
              whiteSpace: "nowrap", // Force single line on large
            }}
            className="hero-title"
          >
            Become Part of Something Bigger
          </Title>

          {/* Paragraph */}
          <Paragraph
            style={{
              color: "#fff",
              fontSize: "clamp(16px, 2.5vw, 20px)",
              textShadow: "1px 1px 6px rgba(0,0,0,0.6)",
              lineHeight: 1.4,
               fontWeight: 600,
              whiteSpace: "nowrap", // Force single line on large
            }}
            className="hero-text"
          >
            Volunteer at events across the Yalla Nellab, connect, contribute and celebrate community.
          </Paragraph>
        </div>

        {/* Contact Button */}
        <div
          style={{
            position: "absolute",
            bottom: "10%",
            left: "50%",
            transform: "translateX(-50%)",
            textAlign: "center",
            width: "90%",
            maxWidth: 400,
          }}
        >
          <Button
            type="primary"
            style={{
              backgroundColor: "#480558",
              borderColor: "#480558",
              color: "#fff",
              fontWeight: 700,
              fontSize: 18,
              padding: "26px 40px",
              borderRadius: 50,
              width: "100%",
              maxWidth: 400,
            }}
            onClick={handleJoinVolunteer}
          >
            Join as Volunteer
          </Button>
        </div>
      </div>

      {/* Why Volunteer Section */}
      <div
        style={{
          width: "100%",
          padding: "80px 20px",
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        <HeartFilled style={{ fontSize: 48, color: "#480558", marginBottom: 20 }} />
        <Title
          level={2}
          style={{
            color: "#000",
            fontWeight: 700,
            fontSize: "clamp(24px, 4vw, 36px)",
            marginBottom: 30,
          }}
        >
          Why be A Volunteer?
        </Title>
        <ul
          style={{
            listStyleType: "disc",
            paddingLeft: "calc(60px + 10%)",
            maxWidth: 600,
            margin: "0 auto",
            textAlign: "left",
            fontSize: "clamp(16px, 2.5vw, 20px)",
            lineHeight: 1.8,
          }}
        >
          <li>Certificate of Contribution after each event</li>
          <li>Real-world experience in event support</li>
          <li>New friendships and community connections</li>
        </ul>
      </div>

      {/* Updated Upcoming Events Section */}
      <div
        style={{
          padding: "0 24px",
          maxWidth: "100%",
          margin: "0 auto",
          backgroundColor: "#F7F7F7",
          borderRadius: "0px",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: "#000",
            marginBottom: "20px",
            textAlign: "left",
          }}
        >
          Upcoming Events
        </h2>

        <div
          style={{
            display: "flex",
            gap: "20px",
            justifyContent: "space-between",
            flexWrap: "nowrap",
          }}
        >
          {upcomingEvents.map((event, idx) => (
            <div
              key={idx}
              className="news-tile"
              style={{
                flex: "1 1 0",
                textAlign: "left",
                overflow: "hidden",
                cursor: "pointer",
                borderRadius: "12px",
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                position: "relative",
              }}
              onClick={() => handleEventClick(event.path)}
            >
              <div className="news-image-container">
                <img
                  src={event.img}
                  alt={event.name}
                  className="news-image"
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    marginBottom: "12px",
                    transition: "all 0.4s ease",
                  }}
                />
                <div className="news-overlay" />
              </div>
              <div style={{ padding: "0 16px 16px" }}>
                <p
                  style={{
                    color: "#373737",
                    fontSize: "16px",
                    lineHeight: "1.4",
                    margin: 0,
                  }}
                >
                  {event.text}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ height: "40px" }} />

      {/* Responsive Style */}
      <style>
        {`
          @media (max-width: 900px) {
            .hero-title, .hero-text {
              white-space: normal !important;
            }
            
            .news-tile:hover {
              transform: translateY(-8px);
              box-shadow: 0 12px 24px rgba(0,0,0,0.15);
            }

            .news-image {
              transition: all 0.4s ease;
            }

            .news-tile:hover .news-image {
              transform: scale(1.08);
            }

            .news-overlay {
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.1) 100%);
              opacity: 0;
              transition: opacity 0.3s ease;
            }

            .news-tile:hover .news-overlay {
              opacity: 1;
            }

            /* Mobile responsive */
            @media (max-width: 768px) {
              .news-tile {
                flex: 1 1 100% !important;
                margin-bottom: 20px;
              }
              
              .news-tile:hover {
                transform: none;
              }
              
              .news-tile:active {
                transform: scale(0.98);
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default Volunteer;